import { render, staticRenderFns } from "./PopupDeleteConfirm.vue?vue&type=template&id=2be0d7b5"
import script from "./PopupDeleteConfirm.vue?vue&type=script&lang=js"
export * from "./PopupDeleteConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports